var map = {
	"./about-bg.jpg": 6,
	"./about1.jpg": 567,
	"./ai-ml.jpg": 51,
	"./appdevelopment.jpeg": 300,
	"./call-to-action-bg.jpg": 556,
	"./cloud-services.jpg": 487,
	"./cloud-solutions.jpg": 827,
	"./contact-hero-bg-1.jpg": 186,
	"./contact-hero-bg.jpg": 852,
	"./cybersecurity.jpg": 962,
	"./development.jpg": 356,
	"./facts-bg.jpg": 623,
	"./office-image.jpg": 868,
	"./servicepage1.jpg": 486,
	"./servicepage2.jpg": 273,
	"./servicepage3.jpg": 676,
	"./software-dev.jpg": 18,
	"./staffing.jpg": 965,
	"./team-meeting.jpg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;